import { Buttons } from "../../../generic-sprites/Buttons"
import { RadioButton } from "../../../generic-sprites/RadioButtons"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { Videos } from "../../../utils/Videos"
import { kidsChoiceVideo, kidsChoiceVideoPreview } from "../KidsChoiceAssets"
import { KidsChoicePartOneState } from "../KidsChoicePartOneState"
import { KidsChoiceStore } from "../KidsChoiceStore"
import {
    KidsChoiceCategoryType,
    KidsChoiceHealthVideos,
    KidsChoiceSecondHandVideos,
    KidsChoiceSprite,
    KidsChoiceVideoChoice,
} from "../KidsChoiceTypes"

export class KidsChoiceVideoSelection implements KidsChoiceSprite {
    voteButton: RadioButton

    private readonly preview: Phaser.Sprite

    constructor(
        private game: Phaser.Game,
        private type: KidsChoiceCategoryType,
        public choice: KidsChoiceVideoChoice,
        index: number,
        private onPlay: () => void,
        private onComplete: () => void,
        onVote: () => void,
        group: Phaser.Group,
    ) {
        this.preview = Sprites.add(game, kidsChoiceVideoPreview(choice), {
            debug: true,
            group,
            scale: 0.25,
        })
        Sprites.centerSpriteInSprite(
            KidsChoicePartOneState.centerRectangle,
            this.preview,
        )
        this.enable()

        this.preview.y += Scale.y(0.22)
        const xDelta = Scale.x(0.15)
        switch (index) {
            case 0:
                this.preview.x -= xDelta
                break
            case 1:
                this.preview.x += xDelta
                break
            default:
                throw new Error("Invalid index given.")
        }

        const onSelect = () => {
            if (this.type === KidsChoiceCategoryType.HEALTH_EFFECTS) {
                KidsChoiceStore.instance.votedHealth =
                    choice as KidsChoiceHealthVideos
            } else {
                KidsChoiceStore.instance.votedSecondhand =
                    choice as KidsChoiceSecondHandVideos
            }
            onVote()
        }
        const voteX = this.preview.x + this.preview.width / 2
        const voteY = this.preview.y + this.preview.height + Scale.y(0.02)
        this.voteButton = new RadioButton(game, group, onSelect, voteX, voteY)
        this.voteButton.setVisible(false)
    }

    set visible(v: boolean) {
        this.preview.visible = v
    }

    enable = () => {
        Buttons.makeSpriteButton(this.preview, this.onClick)
        this.visible = true
    }

    disable = () => Buttons.undoSpriteButton(this.preview)

    setWatched = () => Sprites.grayOut(this.preview)

    unsetWatched = () => Sprites.undoGrayOut(this.preview)

    hide = () => {
        this.disable()
        this.visible = false
    }

    destroy = () => {
        this.preview.destroy()
        this.voteButton.destroy()
    }

    private onClick = async () => {
        const video = await Videos.add(
            this.game,
            kidsChoiceVideo(this.choice),
            {
                scale: 0.5,
                onComplete: () => {
                    video.destroy()
                    if (this.type === KidsChoiceCategoryType.HEALTH_EFFECTS) {
                        KidsChoiceStore.instance.addHealthVideo(this.choice)
                    } else {
                        KidsChoiceStore.instance.addSecondhandVideo(this.choice)
                    }
                    this.onComplete()
                },
                onPlay: this.onPlay,
            },
        )
        Sprites.centerSpriteInSprite(
            KidsChoicePartOneState.centerRectangle,
            video.videoImage,
        )
        video.videoImage.y += Scale.y(0.22)
    }
}
